import { debounce } from "lodash";
import { useMemo } from "react";

import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export type PasswordStrengthPayload = {
  password: string;
  email?: string;
  username?: string;
  first_name?: string;
  last_name?: string;
};

export const usePasswordStrengthMutation = () => {
  const mutation = useTypedMutation<PasswordStrengthPayload, number>({
    mutationFn: async payload => (await ApiInstance.post("/users/password/strength", payload, ENV.systemBaseURL)).data.strength,
    onSuccess: () => null
  });

  const checkPasswordStrength = useMemo(() => debounce((payload: PasswordStrengthPayload) => mutation.mutate(payload), 500), [mutation.mutate]);

  return { checkPasswordStrength, strength: mutation.isError ? null : (mutation.data ?? null), resetPasswordStrength: mutation.reset };
};
